import { ParseBaseRepository } from '../../parse-base.repository';
import { RoleTopology } from '../../repositories';
import { GetUserRoles, type IGetUserRolesHandler, RoleItem } from '@telespot/authentication/use-cases';

export class ParseGetUserRolesHandler extends ParseBaseRepository implements IGetUserRolesHandler {
  public async execute(command: GetUserRoles): Promise<RoleItem[]> {
    const { userId } = command.details;

    const userPointer = this.parse.User.createWithoutData(userId);

    const query = new this.parse.Query(this.parse.Role).containedIn(RoleTopology.USERS, [userPointer]);

    const roles = await query.find(this.options);

    return roles.map((role) => ({ id: role.id ?? '', name: role.getName() }));
  }
}
